export const SOCKET_RECONNECT_TIMEOUT = 20000;

export const reconnectAndAuthenticate = ({
  socket,
  socketApp,
  token,
  timeoutMs = SOCKET_RECONNECT_TIMEOUT,
  forceTransportReconnect = false,
}) => new Promise((resolve, reject) => {
  let settled = false;
  let timer = null;

  const cleanup = () => {
    if (timer) clearTimeout(timer);
    socket.off("connect", handleConnect);
    socket.off("connect_error", handleConnectError);
  };

  const finish = (callback, value) => {
    if (settled) return;
    settled = true;
    cleanup();
    callback(value);
  };

  const authenticate = async () => {
    try {
      if (!token) throw new Error("No hay una sesión para autenticar el socket");
      socketApp.authentication?.setAccessToken?.(token);
      await socketApp.reAuthenticate(true);
      finish(resolve, true);
    } catch (error) {
      finish(reject, error);
    }
  };

  function handleConnect() {
    authenticate();
  }

  function handleConnectError(error) {
    finish(reject, error || new Error("No fue posible conectar el socket"));
  }

  socket.on("connect", handleConnect);
  socket.on("connect_error", handleConnectError);
  timer = setTimeout(
    () => finish(reject, new Error("Tiempo de conexión agotado")),
    timeoutMs
  );

  try {
    if (socket.connected) authenticate();
    else {
      if (forceTransportReconnect) socket.io?.close?.();
      socket.connect();
    }
  } catch (error) {
    finish(reject, error);
  }
});
